// extracted by mini-css-extract-plugin
export default {"cultureLink":"cultureLink-hS1Dp","cultureCellLine":"cultureCellLine-P3BXC"};